import { ZoomImageContainer } from "shared/components/Parameters";
import Layout from "../../components/mainPage/Layout";
import KafkaClient from "../../images/systemComponents/KafkaClient.svg";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    Kafka клиент
                </h1>
                <div className=" w-100 align-start  ">
                    <p >
                        Использование <b>Kafka клиента</b> в SCADA NPT Expert позволяет решать задачи, связанные с обработкой большого потока данных в реальном времени, обеспечением масштабируемости и интеграцией различных компонентов системы.
                    </p>
                    <p>Apache Kafka (Kafka) — это распределенная платформа для обработки непрерывных потоков данных в реальном времени. В Kafka данные организованы в виде сообщений, а не записей, как в реляционных базах данных. Эти сообщения могут быть как структурированными данными, так и неструктурированными событиями. Kafka ориентирована на обработку потоков данных и является распределенной системой потоковой обработки.</p>
                    <div style={{ float: 'right' }}>
                        <div style={{ maxWidth: '500px' }}>
                            <ZoomImageContainer
                                image={KafkaClient}
                            />
                            {/* <img
                                src={KafkaClient}
                                className="mb-4 w-100 "
                                alt="Kafka Клиент"
                            /> */}
                        </div>
                    </div>
                    <div>
                        <p>Основные задачи, которые решает использование Kafka клиента в SCADA NPT Expert, включают:</p>

                        <ul className="mb-4 description__list">

                            <li className="mb-1 description__number-li"><b>Обработка больших объемов данных в реальном времени</b>
                                <ul>
                                    <li>Kafka позволяет SCADA-системам обрабатывать большие потоки данных, поступающих от тысяч устройств (датчиков, контроллеров), в режиме реального времени. Это особенно важно для систем, где требуется мгновенная реакция на события.
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Обеспечение масштабируемости</b>
                                <ul>
                                    <li>Kafka поддерживает горизонтальное масштабирование, что позволяет SCADA-системам легко адаптироваться к увеличению числа устройств и объема данных.</li>
                                    <li>Распределенная архитектура Kafka обеспечивает высокую производительность даже при высокой нагрузке. </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Надежное хранение и передача данных</b>
                                <ul>
                                    <li>Kafka сохраняет все сообщения на диске и обеспечивает их репликацию между узлами кластера, что гарантирует надежность и отказоустойчивость.</li>
                                    <li>Данные могут быть сохранены на длительный период, что полезно для анализа и аудита.</li>
                                    <li>Kafka позволяет настраивать задержку доставки сообщений, что может быть полезно для реализации сценариев, требующих отложенной обработки данных.</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Организация потоковой обработки данных</b>
                                <ul>
                                    <li>Kafka поддерживает потоковую обработку данных, что позволяет SCADA
                                        <ul>
                                            <li>Анализировать данные в реальном времени.</li>
                                            <li>Выявлять аномалии.</li>
                                            <li>Принимать оперативные решения на основе актуальной информации.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Обеспечение безопасности</b>
                                <ul>
                                    <li>Kafka поддерживает механизмы аутентификации, авторизации и шифрования (например, TLS/SSL), что обеспечивает защиту данных от несанкционированного доступа. Это особенно важно для SCADA-систем, работающих в критически важных отраслях.   </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Интеграция разнородных систем</b>
                                <ul>
                                    <li>Kafka позволяет интегрировать SCADA с различными внешними системами, такими как:
                                        <ul>
                                            <li>Базы данных.</li>
                                            <li>Аналитические платформы.</li>
                                            <li>ERP-системы.</li>
                                            <li>IoT-платформы.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li"><b>Мониторинг и управление</b>
                                <ul>
                                    <li>Kafka предоставляет инструменты для мониторинга состояния очередей, производительности и нагрузки на систему. Это позволяет администраторам своевременно выявлять и устранять проблемы.
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </div>

                    <div style={{ clear: 'both' }}></div>
                </div>

            </div>
        </div>
    </Layout>
}

export const meta = {
    title: 'Kafka клиент',
    description: 'Использование Kafka клиента в SCADA NPT Expert позволяет решать задачи, связанные с обработкой большого потока данных в реальном времени, обеспечением масштабируемости и интеграцией различных компонентов системы.'
}